/**
 * Flare pooled-staking LST surface — SparkDEX `stFLR` and Sceptre `sFLR`.
 *
 * Both are Lido-style rebasing share tokens over native FLR: deposits
 * (`submit()` / `deposit()`) mint shares, `totalPooledFlr()` is the total
 * underlying FLR held, `totalShares()` is the non-rebasing share count, and
 * `getPooledFlrByShares(1e18)` is the 1e18-scaled rate (1 share → FLR).
 */
export const FlarePooledFlrAbi = [
  {
    name: 'totalPooledFlr',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'totalShares',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'getPooledFlrByShares',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ name: 'shares', type: 'uint256' }],
    outputs: [{ type: 'uint256' }],
  },
] as const
